<template>
  <div id="MainLoading" ref="MainContent">
    <div class="dialog_box" data-dialog-box>
      <img src="/img/logo_black.svg" />
      <p></p>
    </div>

    <div class="background_box" data-dialog-background></div>
  </div>
</template>

<script>
import { MainDialog } from "@/animations/mainDialog";
export default {
  name: "MainLoading",
  data() {
    return {
      animation: null,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new MainDialog(this.$refs.MainContent);
      this.animation.Reset();
      if (this.loadingCount > 0) {
        this.animation.Open();
      }
    },
  },
  computed: {
    loadingCount() {
      return this.$store.state.loadingCount;
    },
  },
  watch: {
    loadingCount(newVal, oldVal) {
      if (oldVal == 0 && newVal > 0) {
        this.$store.commit("setLoadingFinish", false);
        this.animation.Open();
      } else if (oldVal > 0 && newVal <= 0) {
        this.animation.Close();
        this.$store.commit("setLoadingFinish", true);
      }
    },
  },
  mounted() {
    this.InitAnimation();
  },
};
</script>
